<div #wrapper class="wrapper" style="height: 100%;">
    <div class="modal-header-wrapper">
        <div class="text-wrapper" [class.font-weight-600]="true">{{ 'select_dial_code' | localise }}</div>
        <div class="responsive-flex-wrapper shortcuts">
            <i class="ti-close" (click)="bsModalRef.hide()"></i>
        </div>
    </div>

    <ng-container>
        <div class="modal-body">
            <div class="search-wrapper animated fadeInDown">
                <input #search type="text" [(ngModel)]="searchText"/>
                <div class="responsive-flex-wrapper">
                    <i class="fa fa-search"></i>
                </div>
                <div class="responsive-flex-wrapper" *ngIf="!search.value">{{ 'search' | localise }}</div>
            </div>

            <div class="dial-codes">
                <div class="dial-code"
                     *ngFor="let code of dialCodes | callback: filterDialCodes:this"
                    (click)="selectDialCode(code)">
                    <div class="dial-component dial-country-code">
                        <img [src]="getFlagSvgPath(code.code.toLowerCase())" width="36"/>
                    </div>
                    <div class="dial-component dial-dial-code">
                        {{ code.dial_code }}
                    </div>
                    <div class="dial-component dial-name">
                        {{ code.name }}
                    </div>

                </div>
            </div>

        </div>
    </ng-container>
</div>
